module.exports = __webpack_public_path__ + "static/media/MTM_ICON_non_an.5280b48a.svg";